import * as R from 'remeda';
import { ActionType } from 'typesafe-actions';

import * as improvementsActions from './actions';
import * as improvementsConstants from './constants';
import improvementsReducer from './reducer';
import * as improvementsSagas from './sagas';
import * as improvementsSelectors from './selectors';

export type ImprovementsState = {
  activeTabId: 'suggestions' | 'actions' | 'simulate';
  selectedSuggestionId: null | string;
  selectedActionId: null | string;
  // Per-tab single-select improvement-area filter.
  //   - `null` = "All" (no filter)
  //   - real id = filter to that area
  //   - sentinel `UNASSIGNED_AREA_ID` = rows with null improvementAreaId
  // The dropdown lives in each view's list card (next to the + add button)
  // and doubles as the default `improvementAreaId` when creating via +.
  // State is per-tab so switching tabs preserves each side's selection.
  suggestionsAreaId: string | null;
  actionsAreaId: string | null;
  // Actionboard sub-view state — drives the (currently commented-out) simulate
  // tab's week stepper + zone/activity resolution toggle.
  actionboard: {
    selectedWeek: Time.Week;
    selectedEntityId: null | string;
  };
};

export type ImprovementsAction = ActionType<typeof improvementsActions>;

const _improvementsSagaActions = R.pick(improvementsActions, [
  'startCreateActionFromSuggestion',
  'startSaveSuggestion',
  'startCreateMockSuggestion',
  'startRejectSuggestion',
  'startDeleteSuggestion',
  'startUpdateAction',
  'startDeleteAction',
  'startCreateMockAction',
  'startAddAction',
]);

export type ImprovementsSagaAction = ActionType<
  typeof _improvementsSagaActions
>;

export {
  improvementsActions,
  improvementsConstants,
  improvementsReducer,
  improvementsSagas,
  improvementsSelectors,
};
